import BaseService from "./geral/BaseService";

const base = "AgendCntrDashboard";

const baseDepot = "AgendCntrDepot";

export default class TriagemService extends BaseService {
    constructor() {
        super(base);
    }

    listar (filtro) {
        return super.httpGet(`/${base}/ListarTriagemDepot?${filtro}`);
    }

    validarTriagem(agendId) {
        return super.httpGet(`/${baseDepot}/ValidarTriagem/${agendId}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/TriagemService.js